import { match } from 'ts-pattern'

import { ALL_BILLING_FREQUENCIES, ALL_BILLING_TYPES } from '@sequencehq/utils'
import { ConditionPropertyEditorComponent } from 'Automations/nodeDefinitions/conditions'
import { DiscountOperatorEditor } from './DiscountOperatorEditor'
import { HasDiscountOperatorEditor } from './HasDiscountOperatorEditor'
import { NoOperatorEditor } from './NoOperatorEditor'
import { PriceAttributeOperatorEditor } from './PriceAttributeOperatorEditor'
import { PRICING_MODEL_SELECT_OPTIONS } from './product.constants'

/**
 * Property-level editor for PRODUCT. Routes to the operator-specific
 * editor — each sub-component owns the product picker, the top-level
 * operator dropdown, and the operator-specific second row.
 */
export const ProductPropertyEditor: ConditionPropertyEditorComponent = props =>
  match(props.operator)
    .with('DISCOUNT', () => <DiscountOperatorEditor {...props} />)
    .with('HAS_DISCOUNT', () => <HasDiscountOperatorEditor {...props} />)
    .with('PRICING_MODEL', () => (
      <PriceAttributeOperatorEditor
        {...props}
        field="pricingModel"
        options={PRICING_MODEL_SELECT_OPTIONS}
      />
    ))
    .with('BILLING_FREQUENCY', () => (
      <PriceAttributeOperatorEditor
        {...props}
        field="billingFrequency"
        options={ALL_BILLING_FREQUENCIES}
      />
    ))
    .with('BILLING_TYPE', () => (
      <PriceAttributeOperatorEditor
        {...props}
        field="billingType"
        options={ALL_BILLING_TYPES}
      />
    ))
    .otherwise(() => <NoOperatorEditor {...props} />)
